import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { AvatarModule } from 'ngx-avatars';
import { EmployeeSearchComponent } from '../components/employee-search/employee-search.component';
import { ConductTimelogsDrawerComponent } from '../components/conduct-timelogs-drawer/conduct-timelogs-drawer.component';
import { ConductTimelogsSummaryCardComponent } from '../components/conduct-timelogs-drawer/conduct-timelogs-summary-card/conduct-timelogs-summary-card.component';

@NgModule({
  // declarations: [EmployeeSearchComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    // Standalone component must be included in `imports` before it can be re-exported.
    EmployeeSearchComponent,
    ConductTimelogsDrawerComponent,
    ConductTimelogsSummaryCardComponent,
    AvatarModule
  ],
  exports: [EmployeeSearchComponent, ConductTimelogsDrawerComponent, ConductTimelogsSummaryCardComponent]
})
export class SharedModule { }
